import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import LignePanel from './LignePanel';
import ArticleNonBudgetaireComponent from '../../../components/Mouvement/Panel/ArticleNonBudgetaireComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';

class ArticleNonBudgetairePanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.ARTICLE_NON_BUDGETAIRE;
    this.icon = { name: 'newspaper outline' };
  }

  getLibelle = () => 'Imputation OPO';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.codeArticleNonBudgetaire);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <ArticleNonBudgetaireComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default ArticleNonBudgetairePanel;
